import { ENDPOINT } from 'constants/api';
import postApiData from 'utils/api/postApiData';
import formatURL from 'utils/formatting/formatURL';
import formatObjEmpty from 'utils/formatting/formatObjEmpty';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

interface CreateEmployerParams {
  token: string;
  clientName: string;
  countryCode: string;
  orgType?: string;
  postalCode: string;
  state: string;
  clientWebSiteUrl: string;
  city: string;
  fee?: number;
  feeType?: string;
  streetAddress: string;
  industryKey: string;
}

export const createEmployer = ({
  token,
  clientName,
  countryCode,
  orgType = 'EMPLOYER',
  postalCode,
  state,
  clientWebSiteUrl,
  city,
  fee = 0.20,
  feeType = 'ON_NET_PAY',
  streetAddress,
  industryKey,
}: CreateEmployerParams): Promise<unknown> => postApiData(ENDPOINT.CLIENTS, formatObjEmpty({
  orgType,
  clientName,
  countryCode,
  industryKey,
  currency: 'EUR',
  timezone,
  clientWebSiteUrl: formatURL(clientWebSiteUrl),
  fee,
  feeType,
  taxAddress: {
    countryCode,
    postalCode,
    state,
    line1: streetAddress,
    city,
  },
}), token);
